import { getNextScene } from 'src/lib/stateUtils';
import { State } from 'src/state';

export function shouldShowHeader() {
  return getNextScene() !== 'minigame' && getNextScene() !== 'debut';
}

export function shouldShowFooter(state: State) {
  return (
    !state.care.currentCareAction &&
    getNextScene() !== 'minigame' &&
    getNextScene() !== 'debut'
  );
}
